import { useEvalPageEdits } from 'features/knowledgeDocumentViewer/hooks/useEvalPageEdits'
import { useEvalPageImagePrefetch } from 'features/knowledgeDocumentViewer/hooks/useEvalPageImagePrefetch'
import { useSystemDocumentPageByNum } from 'features/knowledgeDocumentViewer/hooks/useSystemDocumentPageByNum'
import { useSystemDocumentByBqId } from 'features/knowledgeDocumentViewer/hooks/useSystemDocumentsByBqIds'
import { useGeckoPermissions } from 'features/permissions'
import { useEffect } from 'react'

export function EvalPagePrefetcher({
  siteId,
  documentId,
  pageNum,
  hiRes,
  jobId,
  onSettled,
}: {
  siteId: string
  documentId: string
  pageNum: number
  hiRes: boolean
  jobId: string
  onSettled: (jobId: string) => void
}): null {
  const { user } = useGeckoPermissions()
  const page = useSystemDocumentPageByNum({
    bqDocumentId: documentId,
    pageNum,
    systemDocumentEntryId: undefined,
  })
  const document = useSystemDocumentByBqId(documentId)
  const edits = useEvalPageEdits(siteId, documentId, pageNum, user?.email)
  const imagesSettled = useEvalPageImagePrefetch(
    siteId,
    documentId,
    pageNum,
    hiRes
  )
  const settled =
    !page.isLoading && !document.isLoading && !edits.isLoading && imagesSettled
  useEffect(() => {
    if (settled) onSettled(jobId)
  }, [settled, onSettled, jobId])
  // A stalled image must not hold the background queue indefinitely.
  useEffect(() => {
    const timeout = setTimeout(() => onSettled(jobId), 30_000)
    return () => clearTimeout(timeout)
  }, [jobId, onSettled])
  return null
}
